interface ServiceCardProps {
  icon: string;
  title: string;
  description: string;
  features: string[];
}

export default function ServiceCard({ icon, title, description, features }: ServiceCardProps) {
  return (
    <div className="bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-lg p-6 hover:border-crimson transition-all duration-300 group">
      <div className="text-center mb-6">
        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center text-4xl text-gold group-hover:text-crimson transition-colors duration-300">
          <i className={icon}></i>
        </div>
        <h3 className="text-xl font-elegant font-semibold text-white mb-2">{title}</h3>
        <p className="text-gray-300 text-sm leading-relaxed mb-4">{description}</p>
      </div>
      
      <div className="bg-black/30 rounded-lg p-4">
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="text-sm text-gray-300 flex items-center">
              <i className="ri-check-line text-gold mr-2"></i>
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}